import { Component } from '@angular/core';

@Component({
  selector: 'block-ui',
  template: `
    <div class="modern-overlay"></div>

    <div class="modern-loader-container" aria-live="assertive" aria-atomic="true">
      <div class="modern-loader-box">
        <div class="modern-spinner"></div>
        <div class="modern-loader-text">{{ message }}</div>
      </div>
    </div>
  `,
  styles: [`
    /* ===== FULLSCREEN OVERLAY ===== */
    .modern-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(255,255,255,0.75);
      backdrop-filter: blur(4px);
      z-index: 10000;
    }

    /* ===== CENTERED CONTAINER ===== */
    .modern-loader-container {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 10001;
      cursor: wait;
    }

    /* ===== WHITE BOX ===== */
    .modern-loader-box {
      background: #ffffff;
      padding: 25px 35px;
      border-radius: 14px;
      box-shadow: 0 6px 28px rgba(0,0,0,0.18);
      display: flex;
      flex-direction: column;
      align-items: center;
      min-width: 160px;
      animation: fadeInScale .25s ease-out;
    }

    @keyframes fadeInScale {
      from { opacity: 0; transform: scale(0.9); }
      to { opacity: 1; transform: scale(1); }
    }

    /* ===== SPINNER ===== */
    .modern-spinner {
      width: 40px;
      height: 40px;
      border: 4px solid #d4d4d4;
      border-top-color: #2196f3;
      border-radius: 50%;
      animation: spin .8s linear infinite;
    }

    @keyframes spin {
      to { transform: rotate(360deg); }
    }

    /* ===== TEXT ===== */
    .modern-loader-text {
      font-size: 16px;
      font-weight: 600;
      margin-top: 12px;
      color: #333;
      text-align: center;
    }
  `]
})
export class BlockuiComponent {
  message: string = 'Моля, изчакайте да заредя...';
}
